import React from 'react';
import { ComponentWrapper } from '../../helperComponents/ComponentWrapper';
import { BackButtonV2 } from '../../helperComponents/BackButtonV2';
import { DropdownMenu } from '../../helperComponents/DropdownMenu/DropdownMenu';
import { isMobile } from '@mightybyte/rnw.utils.device-info';
import { Platform, StyleSheet, Text, useWindowDimensions, View } from 'react-native';
import { applyTransparency } from '../../../constants/colors';
import LabelCountBox from '../../helperComponents/LabelCountBox';
import { useSignedInContext } from '../../../context/SignedInContext';
import GameAchievements from '../../helperComponents/GameAchievements';
import {
  GAME_OPERATION_TYPE,
  GAME_TYPE_ARRANGEMENT,
  GAME_TYPES_CONFIG,
} from '../../../constants/constants';
import { useGetStreakHistoryByUserQuery } from '../../../graphql/journey/getUserStreakHistory.gql';
import { StreakBadgeNoRect } from '../../../resources/svgComponents/badgeComponents/StreakBadgeNoRect';

export default function NectarNookScreen({ navigation, route }) {
  const { width } = useWindowDimensions();
  const { user } = useSignedInContext();
  const userId = user?.id ?? '';
  const nectarCount = user?.points ?? 0;
  const pathSizeLimit = width < 1161;

  const isMobileWeb = Platform.OS === 'web' && width <= 768;

  const { data } = useGetStreakHistoryByUserQuery({
    variables: { userId },
  });

  const streakHistory =
    data?.streakHistoryByUser?.history
      .map(h => ({
        ...h,
        streakCount: Number(h.streakCount ?? 0), // force number
      }))
      .sort((a, b) => a.streakCount - b.streakCount) ?? [];

  const goBackToLobby = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate('Lobby');
    }
  };
  return (
    <ComponentWrapper hasInset hasScroll={true} hideBee={true}>
      <DropdownMenu
        backButton={
          <BackButtonV2
            onPress={() => {
              goBackToLobby();
            }}
          />
        }
        top={20}
      />

      {!pathSizeLimit && (
        <View style={[styles.nectarButtonsContainer]}>
          <LabelCountBox countText={String(nectarCount)} />
        </View>
      )}

      <Text
        style={[styles.title, isMobile && { marginTop: 50 }, isMobileWeb && { marginTop: 100 }]}
      >
        Nectar Nook
      </Text>
      <Text style={[styles.subTitle]}>Achievements</Text>
      <View style={[styles.achievementsContainer, isMobile && { width: '100%' }]}>
        {/* streak badges */}
        <View style={[styles.streakContainer]}>
          <Text style={[styles.streakText]}>Streak Badges</Text>
          {streakHistory.map((streak, idx) => (
            <StreakBadgeNoRect
              key={idx}
              number={streak.streakCount}
              numberFontSize={12}
              topNumberPos={17}
              unitLabel={'DAYS'}
            />
          ))}
        </View>
        {
          <View
            style={[
              styles.medalContainer,
              { flexDirection: isMobile ? 'column' : 'row', alignItems: 'flex-start' },
            ]}
          >
            <View style={[{ flexDirection: 'column', alignItems: 'flex-start' }]}>
              <View style={[styles.operationsContainer]}>
                {GAME_TYPE_ARRANGEMENT.filter(
                  type => GAME_TYPES_CONFIG[type].operation === GAME_OPERATION_TYPE.ADDITION,
                ).map(type => (
                  <GameAchievements key={type} gameType={type} />
                ))}
              </View>
              <View style={[styles.operationsContainer]}>
                {GAME_TYPE_ARRANGEMENT.filter(
                  type => GAME_TYPES_CONFIG[type].operation === GAME_OPERATION_TYPE.SUBTRACTION,
                ).map(type => (
                  <GameAchievements key={type} gameType={type} />
                ))}
              </View>
              <View style={[styles.operationsContainer]}>
                {GAME_TYPE_ARRANGEMENT.filter(
                  type => GAME_TYPES_CONFIG[type].operation === GAME_OPERATION_TYPE.DIVISION,
                ).map(type => (
                  <GameAchievements key={type} gameType={type} />
                ))}
              </View>
            </View>
            <View style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
              <View style={[styles.operationsContainer]}>
                {GAME_TYPE_ARRANGEMENT.filter(
                  type => GAME_TYPES_CONFIG[type].operation === GAME_OPERATION_TYPE.MULTIPLICATION,
                ).map(type => (
                  <GameAchievements key={type} gameType={type} />
                ))}
              </View>
            </View>
          </View>
        }
      </View>
    </ComponentWrapper>
  );
}

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Secular One',
    fontSize: 28,
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
    color: '#E87030',
    marginTop: 100,
  },
  subTitle: {
    fontFamily: 'Secular One',
    fontSize: 18,
    fontWeight: '400',
    color: '#000000',
    marginTop: 18,
  },
  nectarButtonsContainer: {
    position: 'absolute',
    top: 20,
    right: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 20,
  },
  achievementsContainer: {
    width: 840,
    paddingHorizontal: 0,
  },
  operationsContainer: {
    marginTop: 24,
    position: 'relative',
  },
  streakContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: '#F3DDA5',
    borderRadius: 16,
    padding: 12,
    marginTop: 24,
    width: '100%',
    gap: 6,
  },
  streakText: {
    fontFamily: 'Secular One',
    fontSize: 16,
    fontWeight: '400',
    color: '#000000',
    marginRight: 12,
  },
  medalContainer: {
    gap: 38,
  },
});
